import React from "react";
import Hero from "@/components/sections/Hero";
import TrustedBy from "@/components/sections/TrustedBy";
import ServicesGrid from "@/components/sections/ServicesGrid";
import AboutSection from "@/components/sections/AboutSection";
import ProcessSection from "@/components/sections/ProcessSection";
import CallScheduler from "@/components/sections/CallScheduler";
import ContactForm from "@/components/sections/ContactForm";

const Home = () => (
  <div data-testid="home-page">
    <Hero />
    <TrustedBy />
    <ServicesGrid />
    <AboutSection />
    <ProcessSection />
    <CallScheduler />
    <ContactForm />
  </div>
);

export default Home;
